import {
  HANDLE_STROKE_SCREEN_PX,
  SELECTION_STROKE_SCREEN_PX,
  handleChromeWorldMetrics,
} from './selectionChrome';

function clampZoom(zoom: number): number {
  return zoom > 0 ? zoom : 1;
}

export interface SelectionHandleVisualProps {
  zoom: number;
  className?: string;
}

/** 缩放手柄可视方块：屏幕固定尺寸，热区仍由外层 world 尺寸承担 */
export function SelectionHandleVisual({ zoom, className }: SelectionHandleVisualProps) {
  const z = clampZoom(zoom);
  const { visualSizePx } = handleChromeWorldMetrics(zoom);
  const inner = visualSizePx * z;

  return (
    <div
      className={className}
      style={{
        width: inner + HANDLE_STROKE_SCREEN_PX * 2,
        height: inner + HANDLE_STROKE_SCREEN_PX * 2,
        transform: `scale(${1 / z})`,
        transformOrigin: 'center center',
        boxSizing: 'border-box',
        border: `${HANDLE_STROKE_SCREEN_PX}px solid var(--accent)`,
        backgroundColor: 'var(--surface)',
      }}
    />
  );
}

/** 旋转柄连线：屏幕固定长度与线宽 */
export function SelectionRotationStem({
  zoom,
  lineHeightWorld,
}: {
  zoom: number;
  lineHeightWorld: number;
}) {
  const z = clampZoom(zoom);

  return (
    <div
      style={{
        width: SELECTION_STROKE_SCREEN_PX * z,
        height: lineHeightWorld * z,
        transform: `scale(${1 / z})`,
        transformOrigin: 'bottom center',
        backgroundColor: 'var(--accent)',
      }}
    />
  );
}
